module.exports = __webpack_public_path__ + "img/zho.ef730b55.png";